import { SET_HEADER_TABS_CONFIG } from './_types';

export const setHeaderTabsConfig = headerTabsConfig => ({
  type: SET_HEADER_TABS_CONFIG,
  payload: headerTabsConfig,
});
